import React from "react";
import classNames from "classnames";
import { UpsellPanelSteps } from "../../../../../constants/upsellPanelEnumsAndConstants";
import { Constants } from "../../../../../constants/constants";
import { isEurekaDomain, isIntelligentInvestorDomain, isInvestsmartDomain } from "../../../../../utils/utils";
import { useUpsellWidgetModel } from '../../../hooks/useUpsellWidgetModelContext';
import { useUpsellWidgetContainer } from '../../../hooks/useUpsellWidgetContainerContext';

export const Step1SignUpFormContent = () => {
  const model = useUpsellWidgetModel();
  const { currentStep } = useUpsellWidgetContainer();
  if (currentStep !== UpsellPanelSteps.Step1SignUp) {
    return null;
  }
  const headingText = Constants.FREE_MEMBERSHIP;
  const headerFontCss = model.IsEurekaFund ? "font-19" : isIntelligentInvestorDomain() ? "font-30" : "font-25"
  const subHeadingText = isInvestsmartDomain() ? "Join InvestSMART today" : isEurekaDomain() ? `Join ${Constants.EUREKA_REPORT} today` : `Join ${Constants.INTELLIGENT_INVESTOR} today`;
  return (
    <>
      {!model.displayQuestionAllSteps && model.content.question && (
        <div className={classNames(headerFontCss, "font-circular-std-bold mb-2")}
          dangerouslySetInnerHTML={{ __html: model.content.question }}></div>
      )}
      {/* Content Paragraph 1 */}
      {model.content.contentParagraph1 && !model.usePopupOverlay && !model.isEurekaFund && (
        <div
          className="font-circular-std-bold upsell-panel-paragraph contentParagraph1 font-40-sm-down"
          dangerouslySetInnerHTML={{ __html: model.content.contentParagraph1 }}
        ></div>
      )}

      {/* Header Section */}
      {(model.usePopupOverlay || model.isEurekaFund) && (
        <div
          className={classNames(
            "font-circular-std-bold upsell-panel-paragraph contentParagraph1",
            headerFontCss,
            {
              "hidden-md-down": !model.isEurekaFundModel,
            }
          )}
        >
          {headingText}
        </div>
      )}

      {/* Alternate Header Section */}
      {model.usePopupOverlay && (
        <div
          className={classNames(
            "upsell-panel-paragraph contentParagraph1 font-circular-std-bold",
            headerFontCss,
            {
              "hidden-lg-up font-19 mt-32 mb-3": model.usePopupOverlay || model.isEurekaFund,
            }
          )}
        >
          {headingText}
        </div>
      )}

      {/* Content Paragraph 2 */}
      {model.content.contentParagraph2 && (
        <div
          className="color-gray-16 font-19 upsell-panel-paragraph contentParagraph2"
          dangerouslySetInnerHTML={{ __html: model.content.contentParagraph2 }}
        ></div>
      )}

      {/* Subheading Section */}
      {(model.usePopupOverlay || model.isEurekaFund) && (
        <div
          className={classNames("font-16 color-gray-16", {
            "mt-3": model.isEurekaFundModel,
          })}
          dangerouslySetInnerHTML={{ __html: subHeadingText }}
        ></div>
      )}
    </>
  );
};
